module.exports = __webpack_public_path__ + "img/right_top.8fee70ed.png";